module.exports = __webpack_public_path__ + "static/media/science-bg-small.ac9931f8.jpg";